import React, { useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import maybeFormatDate from './maybeFormatDate';

const BarChart = ({ data, colours, title = null, chartHeight = 300, type = null, inputType = null }) => {
    const ref = useRef(null);

    const chartData = data.map(e => {
        const { str } = maybeFormatDate(e.name, inputType);

        return str;
    });

    const options = {
        grid: {
            containLabel: true
        },
        tooltip: {
            trigger: 'item',
            formatter: params => `${params.marker}${params.name}: <b>${params.value}</b>`
        },
        yAxis: {
            type: 'category',
            data: chartData,
            axisLabel: {
                interval: 0
            },
            ...(type === 'ranking' && {
                inverse: true
            })
        },
        xAxis: {
            type: 'value',
            minInterval: 1
        },
        color: colours,
        series: [
            {
                data: data.map(e => e.value),
                type: 'bar',
                colorBy: 'data'
            }
        ],
        ...(title && {
            title: {
                text: title
            }
        })
    };

    const height = Boolean(chartHeight >= 300) ? chartHeight : 300;

    return (
        <ReactECharts
            option={options}
            style={{ height }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default BarChart;
